import { faCopy, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useHelpers from "Hooks/useHelpers";
import useUserContext from "Hooks/useUserContext";
import { useState } from "react";
import styles from "Pages/Setup/Configuration/Components/HideOrShowPassword/HideOrShowPassword.module.css";
import { UncontrolledTooltip } from "reactstrap";

/** This component displays an eye icon which can be clicked to hide or show a
 * secret value like a password that is passed in. Also has the copy to clipboard icon.
 */
export const HideOrShowPassword = (value: string, row: number) => {
    const stars = getStars();
    const [valueShown, setValueShown] = useState<string>(stars);

    const [userContext] = useUserContext();
    const { copyToClipboard } = useHelpers();

    const showOrHideValue = () => {
        if (valueShown === stars) {
            setValueShown(value);
        } else {
            setValueShown(stars);
        }
    };

    function getStars() {
        const length = Math.min(10, value.length);
        const stars = "*".repeat(length);

        return stars;
    }

    const copyIconId = "copyIcon" + row;
    const showOrHideIconId = "showOrHideIcon" + row;

    return (
        <span className={styles.eyeIconAndContentBox}>
            {userContext.isCalanceAdmin === "1" && (
                <>
                    <FontAwesomeIcon
                        id={copyIconId}
                        className={styles.copyIcon}
                        onClick={() => copyToClipboard(value)}
                        icon={faCopy}
                    />
                    <UncontrolledTooltip target={copyIconId}>
                        Copy to clipboard
                    </UncontrolledTooltip>
                    <FontAwesomeIcon
                        id={showOrHideIconId}
                        className={styles.showOrHideIcon}
                        onClick={showOrHideValue}
                        icon={faEye}
                    />
                    <UncontrolledTooltip target={showOrHideIconId}>
                        Show/hide value
                    </UncontrolledTooltip>
                </>
            )}
            <span>{valueShown}</span>
        </span>
    );
};
